import styled from '@emotion/styled';
import React from 'react';
import { headerImage } from '../../assets';

const HeaderContainer = styled.div`
display: flex;
align-items: center;
justify-content: center;
background-image: url(${props => props.imageUrl});
background-repeat: repeat-x;
background-size: cover;
height: 200px;
position: relative;
`;

function HeaderImage({ children }) {
    return (
        <HeaderContainer imageUrl={headerImage}>
            {children}
        </HeaderContainer>
    )
}

export default HeaderImage